import React from 'react';
import { Text, View, ViewStyle } from 'react-native';
import { styles } from './Attribution.styles';
import Logo from '../Logo/Logo';

interface Props {
  mode?: 'light' | 'dark';
  containerStyles?: ViewStyle | ViewStyle[];
}

export const Attribution: React.FC<Props> = ({
  mode = 'light',
  containerStyles,
}) => {
  const isLight = mode === 'light';

  return (
    <View style={[styles.container, containerStyles]}>
      <Text style={[styles.text, !isLight && styles.textDark]}>Powered By</Text>
      <Logo height={14} type="logotype" color={isLight ? 'light' : 'dark'} />
    </View>
  );
};
